import { ExperimentOfferFlow, PaymentData, PaymentInfo, SubscriptionStatus } from "../types";

export class SubscriptionData {
  statusData: SubscriptionStatus;
  paymentInfo: PaymentInfo;
  constructor(subscriptionStatus: SubscriptionStatus, paymentInfo: PaymentInfo) {
    this.statusData = subscriptionStatus;
    this.paymentInfo = paymentInfo;
  }

  isPaymentRequired(): boolean {
    // TODO: Revise hard coded nested prop 'basic'
    return (
      !this.statusData.subscription.basic.hasSubscription &&
      !this.statusData.subscription.basic.hasTrial
    );
  }

  missingPaymentInfo(): boolean {
    return Object.keys(this.paymentInfo).length === 0
  }

  getDaysAmount(): number {
    return this.paymentInfo.trial!.days
  }

  getPaymentData(): PaymentData {
    return this.isPaymentRequired()
      ? this.paymentInfo.payment!
      : this.paymentInfo.trial!.paymentAfterTrial;
  }

  getClientSecret(): string {
    return this.isPaymentRequired() ? this.getPaymentSecret() : this.getTrialSecret()
  }

  getCheckoutUrl(): string {
    return this.isPaymentRequired() ?
      this.paymentInfo.payment!.stripeSessionCheckoutUrl ?? '' :
      this.paymentInfo.trial!.stripeSessionCheckoutUrl ?? '';
  }

  getPaymentSecret(): string {
      return this.paymentInfo!.payment!.stripePaymentIntent.clientSecret;
  }

  getTrialSecret(): string {
    return this.paymentInfo.trial!.stripeSetupIntent.clientSecret;
  }

  isPartOfExperiment(): boolean {
    // TODO: Revise hard coded nested prop 'basic'
    return this.statusData.subscription.basic.experimentOfferFlow === ExperimentOfferFlow.stripeCheckout
  }

  isTrialAvailable(): boolean {
    // TODO: Make sure this is the correct way to check if trial is available
    return this.paymentInfo.trial !== undefined
  }
}
